<div class="container" *ngIf="productObject">
  <div class="row my-5 pt-4 pt-sm-0 justify-content-center">
    <div class="col-12">
      <div class="card shadow rounded border-0">
        <div class="card-body">
          <div class="row align-items-center pb-5">
            <!-- Product Img -->
            <div class="col-md-5 d-flex justify-content-center" *ngIf="productObject['PhysicalProductExtraInfo']['image']">
              <img [src]="productObject['PhysicalProductExtraInfo']['image']" class="img-fluid rounded" alt="product">
            </div>

            <!-- Product Info -->
            <div class="col-md-7 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div class="section-title ms-md-4">
                <h4 class="title">{{ productObject['productName'] }}</h4>
                <h5 class="text-muted">
                  {{ vpihs.getExchangedValue(productObject['PhysicalProductExtraInfo']['price'], getNewProductValueByFieldName("currency", "ProductExtraInfos")).toFixed(2) }}
                  {{ getNewProductValueByFieldName("currency", "ProductExtraInfos") }}
                </h5>
                <div class="mt-4 py-2">
                  <span class="h5">{{ 'Buyer.Seller' | translate }} :</span>
                  <a target="_blank" routerLink="/{{businessObject?.name}}" class="text-muted fs-5 name ms-2"> {{businessObject?.name}}</a>
                </div>

                <h5 class="mt-4 pt-2">{{ 'Buyer.Overview' | translate }} :</h5>
                <p class="text-muted">
                  {{ productObject['description'] }}
                </p>

                <div class="d-flex shop-list align-items-center mt-4 py-2">
                  <h6 class="mb-0" *ngIf="maxQuantity > 0">{{ 'Buyer.Quantity' | translate }} :</h6>
                  <div class="qty-icons ms-3" *ngIf="quantity >= 0">
                    <button (click)="quantityChange(-1)"
                            class="btn btn-icon btn-soft-primary minus">
                      -
                    </button>
                    <input min="0" name="quantity" [(ngModel)]="quantity" type="number"
                           class="btn btn-icon btn-soft-primary qty-btn quantity ps-2" disabled>
                    <button (click)="quantityChange(1)" [ngClass]="{'disabled': quantity == maxQuantity}"
                            class="btn btn-icon btn-soft-primary plus">
                      +
                    </button>
                  </div>
                  <p *ngIf="maxQuantity <= 0" class="soldOut">{{ 'Buyer.SoldOut' | translate }}</p>
                </div>
                <div class="row mt-4 pt-2">
                  <div class="col-md-6 mb-3">
                    <span class="fs-5">{{ 'Buyer.Total' | translate }} :</span>
                    <span class="text-primary fs-4 ms-2">
                      {{ vpihs.getExchangedValue((productObject['PhysicalProductExtraInfo']['price'] * quantity), getNewProductValueByFieldName("currency", "ProductExtraInfos")).toFixed(2) }}
                      {{ getNewProductValueByFieldName("currency", "ProductExtraInfos") }}
                    </span>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="text-end row mx-0">
                      <button class="btn btn-primary" type="button" [disabled]="(maxQuantity <= 0) || (quantity <= 0)"
                              (click)="proceedToPayment()">
                        {{ 'Buyer.Next' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Ads -->
          <!--<app-ads [productObject]="productObject"></app-ads>-->


          <div *ngIf="productObject" class="border-top pt-4">
            <div *ngIf="maxQuantity>0" class="col-12 p-5">
              <div class="row justify-content-around align-items-center">
                <div class="col-5"
                     (click)="titledModal.open({title: 'Delivery Terms:', content: productObject.PhysicalProductExtraInfo.deliveryTerms, closeButtonName: 'Ok!'})">
                  {{ 'Buyer.DeliveryTerms' | translate }}
                </div>
                <div class="col-5"
                     (click)="titledModal.open({title: 'Return Terms:', content: productObject.PhysicalProductExtraInfo.returnTerms, closeButtonName: 'Ok!'})">
                  {{ 'Buyer.ReturnTerms' | translate }}
                </div>
                <div class="col-2 text-end">[+]</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
